import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type FixedLanguage = "en" | "de" | "fr";
type FixedLanguageMap = Record<FixedLanguage, string>;

export const useFixedLanguages = () => {
  const { i18n } = useTranslation();

  const tEn = useMemo(() => i18n.getFixedT("en"), [i18n]);
  const tDe = useMemo(() => i18n.getFixedT("de"), [i18n]);
  const tFr = useMemo(() => i18n.getFixedT("fr"), [i18n]);

  return (key: string, options?: Record<string, unknown>): FixedLanguageMap => ({
    en: tEn(key, options),
    de: tDe(key, options),
    fr: tFr(key, options),
  });
};
